import { Link } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { ConfirmationPage } from '~/features/public/pages/consultation/confirmation'
import { WelcomeProgress } from '~/features/public/pages/welcome/components/welcome-progress'
import LogoWL from "~/assets/logo_wl.svg";
import { ConsultationDetailsSearchParams } from '~/features/appointments/schemas';

export const Route = createFileRoute(
  '/(public)/_public/consultations/confirmation',
)({  
  validateSearch: (search: Record<string, unknown>): ConsultationDetailsSearchParams => {
    return {
        consultation_encounter_id: search.consultation_encounter_id as string | undefined,
    };
  },
  component: () => (
      <div className="relative h-full w-full">
        <WelcomeProgress currentStep={12} totalSteps={13} />
        <div className="relative flex h-full w-full flex-col justify-between px-4">
          <Link to="/" className="mx-auto my-[24px] md:my-[40px] lg:my-[50px] xl:my-[60px]">
            <img
              src={LogoWL}
              alt="Proxymed logo"
              className="max-w-[160px] md:max-w-[180px] lg:max-w-[200px] xl:max-w-none"
            />
          </Link>
        </div>
  
        <ConfirmationPage />
      </div>
    ),
  errorComponent: ({ error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Consultations Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})
